module.exports = __webpack_public_path__ + "static/sp_checkout_5-381097af4913b8711dd923c1b71a97f6.jpg";